import { AlignItems, Overflow } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { BorderRadius } from '../../../../enums/borderRadius'
import { Color } from '../../../../enums/color'
import { DefaultValue } from '../../../../enums/defaultValue'
import { FlexProps } from '../../../Flex'

interface SectionWrapperProps extends FlexProps {
  alignment?: AlignItems
  aspectRatio?: string
  bordered?: boolean
  borderRadius?: BorderRadius
  overflowY?: Overflow
}

export const SectionWrapper = styled.div<SectionWrapperProps>`
  display: flex;
  align-items: ${({ alignment }) => alignment || 'flex-start'};
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;

  ${({ overflowY }) => overflowY && `overflow-y: ${overflowY};`}

  ${({ bordered, borderRadius = DefaultValue.BorderRadius }) => {
    if (bordered) {
      return css`
        border: 1px solid ${Color.Grey200};
        border-radius: ${borderRadius};
      `
    }
  }};
`
